import { render } from "./UnpaidOrder.vue?vue&type=template&id=54ff6589&scoped=true"
import script from "./UnpaidOrder.vue?vue&type=script&lang=js"
export * from "./UnpaidOrder.vue?vue&type=script&lang=js"

import "./UnpaidOrder.vue?vue&type=style&index=0&id=54ff6589&scoped=true&lang=css"
import "./UnpaidOrder.vue?vue&type=style&index=1&id=54ff6589&lang=scss"

import exportComponent from "C:\\ProgramData\\Jenkins\\.jenkins\\workspace\\1h_web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54ff6589"]])

export default __exports__